var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgHeading2 = function SvgHeading2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heading-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M12.582 4.302v15.329M12.246 11.732H1.853M1.64 19.631V4.302",
    className: "icon-stroke-width"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.24 19.744c0 .535.418.887 1.063.887h4.936c.579 0 .923-.3.923-.799 0-.505-.352-.813-.923-.813h-3.435v-.095l2.33-2.49c1.252-1.318 1.706-2.146 1.706-3.15 0-1.647-1.392-2.841-3.325-2.841-1.978 0-3.384 1.282-3.384 2.6 0 .49.337.842.827.842.381 0 .63-.198.865-.652.285-.769.835-1.179 1.582-1.179.9 0 1.508.564 1.508 1.399 0 .615-.322 1.172-1.128 2.029l-2.731 2.944c-.616.63-.813.945-.813 1.319Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heading-2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeading2);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;